import { useEffect, useState } from 'react';
import { UseProgressBarProps, UseProgressBarReturn } from '../types';
import {
  INITIAL_PROGRESS,
  MAX_DIFF_VALUE,
  MAX_PROGRESS_VALUE,
  PROGRESS_INTERVAL,
} from '../constants';

const useProgressBar = ({
  isShowingProgressBar,
}: UseProgressBarProps): UseProgressBarReturn => {
  const [progress, setProgress] = useState(INITIAL_PROGRESS);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;

    if (isShowingProgressBar) {
      timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress >= MAX_PROGRESS_VALUE) {
            return oldProgress;
          }

          const diff = Math.random() * MAX_DIFF_VALUE;
          return Math.min(oldProgress + diff, 100);
        });
      }, PROGRESS_INTERVAL);
    }

    return () => {
      clearInterval(timer);
    };
  }, [isShowingProgressBar]);

  return { progress };
};

export default useProgressBar;
